export const parseProps = props => ({
    ...props,
    theme: `simple-keyboard hg-theme-default ${(props.theme)} ${props.colorTheme}`
})

export const keyboardOptions = {
    layout: {
        default: [
            'q w e r t y u i o p',
            ' a s d f g h j k l ',
            '{shiftleft} z x c v b n m _ -',
            '{splchars} {space} . @',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. 0 #',
            '{backspace}'
        ],
        shift: [
            'Q W E R T Y U I O P',
            ' A S D F G H J K L ',
            '{shiftleft} Z X C V B N M _ -',
            '{splchars} {space} . @',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. 0 #',
            '{backspace}'
        ],
        numeric: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. 0 #',
            '{backspace}'
        ],
        splchars: [
            '~ # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `/ : ; ' " , < > _ -`,
            '{abc} {disablespace} . @',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. 0 #',
            '{backspace}'
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '+=<',
        '{disablesplchars}': '+=<',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#'
    },
};
export const keyboardAccountOptions = {
    layout: {
        default: [
            'q w e r t y u i o p',
            ' a s d f g h j k l ',
            '{shiftleft} z x c v b n m {disableuscr} {disabledash}',
            '{disablesplchars} {disablespace} {disabledot} {disableat}',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        shift: [
            'Q W E R T Y U I O P',
            ' A S D F G H J K L ',
            '{shiftleft} Z X C V B N M {disableuscr} {disabledash}',
            '{disablesplchars} {disablespace} {disabledot} {disableat}',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        numeric: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        splchars: [
            '~ # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `/ : ; ' " , < > _ -`,
            '{abc} {disablespace} . @',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '+=<',
        '{disablesplchars}': '+=<',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disablehash}': '#'
    },
};

export const numericKeyboardOptions = {
    layout: {
        default: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. 0 #',
            '{backspace}'
        ],

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '+=<',
        '{abc}': 'ABC',
        '{disabledot}': '.',
        '{disablehash}': '#'
    },
};

export const numericZipKeyboardOptions = {
    layout: {
        default: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '+=<',
        '{abc}': 'ABC',
        '{disabledot}': '.',
        '{disablehash}': '#'
    },
};


export const keyboardOptionsXL = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            ' a s d f g h j k l ',
            '{shiftleft} z x c v b n m @ .',
            '{space} {backspace}',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            ' A S D F G H J K L ',
            '{shiftleft} Z X C V B N M @ .',
            '{space} {backspace}',
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '~ # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ; ' " , < > _ -`,
            '{abc} {space} {backspace}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#'
    },
};

export const keyboardReferralPlanTools = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L @',
            '{shiftleft} Z X C V B N M {backspace}',
            '{splchars} {tab} {space} {accept}',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l @',
            '{shiftleft} z x c v b n m {backspace}',            '{splchars} {tab} {space} {accept}', 
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '. # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ' " , < > _ - {backspace}`,
            '{abc} {tab} {space} {accept}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#',
    },
};

export const keyboardPlanToolsWithSubmit = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L @',
            '{shiftleft} Z X C V B N M {backspace}',
            '{splchars} {space} {accept}',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l @',
            '{shiftleft} z x c v b n m {backspace}',            '{splchars} {space} {accept}', 
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '. # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ' " , < > _ - {backspace}`,
            '{abc} {space}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#',
    },
};

export const keyboardPlanToolsWithSubmitAndTab = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L @',
            '{shiftleft} Z X C V B N M {backspace}',
            '{splchars} {tab} {space} {accept}',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l @',
            '{shiftleft} z x c v b n m {backspace}',            '{splchars} {tab} {space} {accept}', 
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '. # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ' " , < > _ - {backspace}`,
            '{abc} {space}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#',
    },
}

export const keyboardPlanTools = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            'A S D F G H J K L @',
            '{shiftleft} Z X C V B N M {backspace}',
            '{splchars} {space} .',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l @',
            '{shiftleft} z x c v b n m {backspace}',            '{splchars} {space} .', 
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '. # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ' " , < > _ - {backspace}`,
            '{abc} {space}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#',
    },
};

export const alphaNumeric = {
    layout: {
        default: [
            'q w e r t y u i o p',
            ' a s d f g h j k l ',
            '{shiftleft} z x c v b n m {disableuscr} {disabledash}',
            '{disablesplchars} {space} {disabledot} {disableat}',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        shift: [
            'Q W E R T Y U I O P',
            ' A S D F G H J K L ',
            '{shiftleft} Z X C V B N M {disableuscr} {disabledash}',
            '{disablesplchars} {space} {disabledot} {disableat}',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        numeric: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ],
        splchars: [
            '~ # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `/ : ; ' " , < > _ -`,
            '{abc} {space} . @',
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '{disabledot} 0 {disablehash}',
            '{backspace}'
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '+=<',
        '{disablesplchars}': '+=<',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disablehash}': '#'
    },
};

export const keyboardOptionsLocker = {
    layout: {
        default: [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            ' a s d f g h j k l ',
            '{shiftleft} z x c v b n m @ .',
            '{splchars} {space} {backspace}',
        ],
        shift: [
            '1 2 3 4 5 6 7 8 9 0',
            'Q W E R T Y U I O P',
            ' A S D F G H J K L ',
            '{shiftleft} Z X C V B N M @ .',
            '{splchars} {space} {backspace}',
        ],
        splchars: [
            '1 2 3 4 5 6 7 8 9 0',
            '~ # % ^ * ( ) { } +',
            '` ! $ & ? [ ] | \\ =',
            `: ; ' " , < > _ -`,
            '{abc} {space} {backspace}',
        ]

    },
    display: {
        '{shiftleft}': ' ',
        '{splchars}': '?!',
        '{disablesplchars}': '?!',
        '{abc}': 'ABC',
        '{disableabc}': 'ABC',
        '{disabledot}': '.',
        '{disableat}': '@',
        '{disabledash}': '-',
        '{disableuscr}': '_',
        '{disablespace}': ' ',
        '{disablehash}': '#'
    },
};

export const numericLocker = {
    layout: {
        default: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            'Clear 0 {backspace}',
        ],
    },
    display: {},
};
